import { Box, Flex, Icon, ModalHeader, Text } from '@chakra-ui/react'
import { FC } from 'react'
import { IconType } from 'react-icons'

interface Props {
  title: string
  subtitle?: string
  icon?: IconType
  bg?: string
}

const FuModalHeader: FC<Props> = ({
  title,
  subtitle,
  icon,
  bg = '#1d5840'
}) => (
  <ModalHeader
    px={4}
    py={2}
    color="gray.100"
    bg={bg}
    borderTopLeftRadius={5}
    borderTopRightRadius={5}
    borderBottom="3px solid #ECC94B"
  >
    <Flex align="center" gap={2}>
      {icon && <Icon as={icon} boxSize={5} />}
      <Box>
        <Text fontSize="14px" fontWeight="700">
          {title}
        </Text>
        {subtitle && (
          <Text fontSize="11px" fontWeight="400" color="purple.200">
            {subtitle}
          </Text>
        )}
      </Box>
    </Flex>
  </ModalHeader>
)

export default FuModalHeader
